import Taginput from './Taginput'

export default Taginput



// WEBPACK FOOTER //
// ./src/components/taginput/index.js